var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateTaskIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09091 0H22.9091C23.5116 0 24 0.488417 24 1.09091V22.9091C24 23.5116 23.5116 24 22.9091 24H1.09091C0.488417 24 0 23.5116 0 22.9091V1.09091C0 0.488417 0.488417 0 1.09091 0ZM2.18164 21.8182H21.818V2.18182H2.18164V21.8182Z",
    fill: "#0B0B28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5455 18.5452C7.14799 18.5452 7.63641 18.0568 7.63641 17.4543V9.81796C7.63641 9.21547 7.14799 8.72705 6.5455 8.72705C5.94301 8.72705 5.45459 9.21547 5.45459 9.81796V17.4543C5.45459 18.0568 5.94301 18.5452 6.5455 18.5452Z",
    fill: "#3030AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 18.5455C12.6026 18.5455 13.091 18.0571 13.091 17.4546V6.5455C13.091 5.94301 12.6026 5.45459 12.0001 5.45459C11.3976 5.45459 10.9092 5.94301 10.9092 6.5455V17.4546C10.9092 18.0571 11.3976 18.5455 12.0001 18.5455Z",
    fill: "#3030AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4547 18.5452C18.0572 18.5452 18.5456 18.0568 18.5456 17.4543V9.81796C18.5456 9.21547 18.0572 8.72705 17.4547 8.72705C16.8522 8.72705 16.3638 9.21547 16.3638 9.81796V17.4543C16.3638 18.0568 16.8522 18.5452 17.4547 18.5452Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateTaskIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/createTaskIcon.b8bfb21eeb412a182c90d322824c84db.svg";